module.exports = __webpack_public_path__ + "static/Q2_2023_Investor_Presentation-d8a03b5fb19fcb3f255030379d95b134.pdf";